var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linked)?_c('section',{staticClass:"wechat-account"},[_c('p',[_vm._v(_vm._s(_vm.t('account-wechat'))+": "+_vm._s(_vm.t('account-wechat-linked')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }